import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import zhHans from '@/langs/zhHans';
import en from '@/langs/en';
import zhHant from '@/langs/zhHand';
import ar from '@/langs/ar';
import de from "@/langs/de"
import es from '@/langs/es';
import fr from '@/langs/fr';
import id from "@/langs/id"
import it from '@/langs/it';
import ja from '@/langs/ja';
import ko from '@/langs/ko';
import nl from '@/langs/nl';
import pl from '@/langs/pl';
import pt from '@/langs/pt';
import ru from '@/langs/ru';
import sv from '@/langs/sv';
import th from '@/langs/th';
import vi from '@/langs/vi';
import tr from '@/langs/tr';
import bg from '@/langs/bg';
import lt from '@/langs/lt';
import hu from '@/langs/hu';
Vue.use(Vuetify);
Vue.component('my-component', {
    methods: {
        changeLocale() {
            this.$vuetify.lang.current = 'en'
        },
    },
})
export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                // primary: '#131419',
                secondary: "#131419",
                section1_bg: "#fff",//正向bar
                section2_bg: "#fff",//全局背景
                section3_bg: "#fff",//page
                section4_bg: "#f2f2f2",//page
                fontColor1: "#111418",
                fontColor2: "#000",
                fontColor3: "#131419",
                navigation_bg: "#fff",
                border1: "#C2C5CB",
                border2: "#DEDFE2",
                border3: "#C2C5CB",
                border4: "#2b3039",
                border5: "#888F99",
                bar1: "#fff",
                btn_bg1: "#DEDFE2",
                btn_bg2: "#eee",
                btn_bg3: "#DEDFE2",
                active1: "#C2C5CB",
                bar2: "#fff",
                bar3: "#fff",
                bar4: "#fff",
                bar5: "#e1e1e1",
                bar6: "#F1F1F1",
                bar7: "#fff",
                bar8: "#f1f1f1",
                bar9: "#DEDFE0",
                bar10: "#f2f2f2",

            },
            dark: {
                // primary: "#000",
                secondary: "#888f99",
                section1_bg: "#1b1f25",//正向bar
                section2_bg: "#131419",//全局背景
                section3_bg: "#131419",//page
                section4_bg: "#1b1f25",//page
                fontColor1: "#fff",
                fontColor2: "#fff",
                fontColor3: "#aaacb5",
                navigation_bg: "#3a414b",
                border1: "#404851",
                border2: "#202226",
                border3: "#2d323c",
                border4: "#2b3039",
                border5: "#313741",
                bar1: "#131419",
                btn_bg1: "#313741",
                btn_bg2: "#1a1b21",
                btn_bg3: "#888f99",
                active1: "#404851",
                bar2: "#171b21",
                bar3: "#242931",
                bar4: "#1d1e25",
                bar5: "#1e2027",
                bar6: "#191d22",
                bar7: "#1e1e1e",
                bar8: "#1d1e25",
                bar9: "#292b34",
                bar10: "#171b21",
            }
        }

    },
    lang: {
        locales: { zhHans, en, zhHant, ar, de, es, fr, id, it, ja, ko, nl, pl, pt, ru, sv, th, vi,tr,bg,lt,hu },
        current: 'en',
    },
});
